import React from "react";

import { useTranslation } from "react-i18next";

import { BUTTON_VARIANTS } from "../button/Button";
import Modal from "../modal/Modal";
import Player from "../player/Player";
import SimplePlayer from "../player/SimplePlayer";

import type { JSX } from "react";

import type { GetMediaResponse } from "../../api/MediaAPI.types";

interface BasePlayerProps<T extends boolean> {
  isOpen: boolean;
  onClose: () => void;
  isPlaying?: boolean;
  className?: string;
  content: T extends true ? string : GetMediaResponse;
}

interface SimplePlayerProps extends BasePlayerProps<true> {
  useSimplePlayer: true;
}
interface ContentPlayerProps extends BasePlayerProps<false> {
  useSimplePlayer?: false;
}

export default function PlayerModal({
  content,
  className,
  isOpen,
  onClose,
  useSimplePlayer,
  isPlaying,
}: SimplePlayerProps | ContentPlayerProps): JSX.Element | null {
  const { t } = useTranslation("editor-utils");

  const modalActions = [
    {
      label: t("close"),
      onClick: onClose,
      buttonVariant: BUTTON_VARIANTS.SECONDARY,
    },
  ];
  return (
    <Modal
      withDarkBackground
      actions={modalActions}
      isOpen={isOpen}
      onClose={onClose}
      size="md"
    >
      {useSimplePlayer ? (
        <SimplePlayer isPlaying={isPlaying} src={content} />
      ) : (
        <Player isFullSize className={className} item={content} />
      )}
    </Modal>
  );
}
